module.exports = "Статус регистрации: <span class=\"label label-{{$ctrl.color}}\">{{$ctrl.value}}</span>";


//////////////////
// WEBPACK FOOTER
// ./src/components/registration-status/registrationStatus.html
// module id = 135
// module chunks = 0